const initialState = () => ({})

export default api => ({
  state: initialState,

  getters: {},

  mutations: {},

  actions: {
    restoreHeaders: ({ commit }) => {
      api.restoreHeaders()
    },

    getToken: async ({ commit }) => {
      return api.getToken()
    },

    signIn: async ({ commit }, data) => {
      await api.signIn(data)
    },

    signOut: async ({ commit }) => {
      await api.signOut()
    }
  }
})
